import React from 'react';

export default function Disclaimer() {
  return (
    <div className="bg-white min-h-screen py-20 px-6">
      <div className="max-w-5xl mx-auto space-y-6">
        <h1 className="text-4xl font-bold text-charcoal">Disclaimer</h1>
        <p className="text-gray-600">
          Nothing on this site should be construed as legal or tax advice. Strategies described here are general in nature and require your CPA’s approval.
        </p>
        <p className="text-gray-600">
          We do not pursue aggressive credit mills or shady ERC campaigns. Every engagement is documented to survive IRS scrutiny.
        </p>
      </div>
    </div>
  );
}
